export const TRUSTED_BY_AVATARS = {
    src: "https://res.cloudinary.com/dirscuuhp/image/upload/f_auto,q_auto/v1784553453/design_system/avatar-group_jkqykm.webp",
    width: 144,
    height: 36,
} as const;
